import { faFileCode, faLaptopCode, faTv } from '@fortawesome/free-solid-svg-icons';
const serviceData = [
    {
        name: "WEBSITE DESIGN",
        description: "Designed and developed user-friendly website, including optimized check-out page that increased user clicks, and subsequently customer purchases by 20% .Passionate about building world class web applications.",
        icon: faLaptopCode,
    },
    {
        name: "WEB DEVELOPMENT",
        description: "Front-end web developer with a passion for metrics and beating former. Prototyped product features for whitesoft and exechain Inc. Decreased rework by 22% and costs by 15%. Consistently receive high user experience .",
        icon: faTv,
    },
    {
        name: "FULL STACK ",
        description: "Hard-working web developer with a flair for creating elegant solutions in the least amount of time. Developed an ecommerce webapp, customer web portal, documentary launch website. Regular attendee of web developer meetups and hackathons.",
        icon: faFileCode,
    }
]
export default serviceData;